<template>
    <div>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow"
                    :gutter="16">
                    <Col span="24">
                    <search-card :form="mainTable.searchForm"
                        :table-load-event="getMainTableRecords"
                        :table-search="mainTable.tableSearch" />
                    </Col>
                </Row>
            </transition>

            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">现售仓明细</span>
                        <Checkbox v-model="amountFilter"
                            @on-change="onShowHasStockOnly">只看有仓存</Checkbox>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                        <Button type="success"
                            size="small"
                            class="btns"
                            shape="circle"
                            @click="onEntry">现售入库单</Button>
                        <Button type="warning"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="onTransformList">调拨单</Button>
                        <Button type="info"
                            size="small"
                            class="btns"
                            shape="circle"
                            @click="onDiscard">现售报损单</Button>
                        <Button type="error"
                            size="small"
                            class="btns"
                            shape="circle"
                            @click="onAgentEntry">内部购销入库单</Button>
                        <Button type="error"
                            size='small'
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            ghost
                            @click="onClickImport()">导入</Button>
                        <Button type="info"
                            size='small'
                            class="btns"
                            shape="circle"
                            @click="onExport()">导出</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="storeList"
                    :loading="mainTable.tableLoading"
                    :extHeight="60"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>

            <Modal v-model="adjustModal.show">
                <p slot="header"
                    style="color:#f60;text-align:center">
                    <Icon type="ios-information-circle" />
                    <span>请输入调整后价格</span>
                </p>

                <currency-input v-model="adjustModal.form.warehouseProductStoreLastAdjustPrice" />

                <div slot="footer">
                    <Button :loading="adjustModal.loading"
                        type="primary"
                        long
                        @click="onAdjustPrice">调价</Button>
                </div>
            </Modal>

            <Modal v-model="transferModal.show">
                <p slot="header"
                    style="color:#f60;text-align:center">
                    <Icon type="ios-information-circle" />
                    <span>请输入需要转换的数量</span>
                </p>

                <integer-input v-model="transferModal.form.transferCount" />

                <div slot="footer">
                    <Button :loading="transferModal.loading"
                        type="primary"
                        long
                        @click="onTransfer">转换</Button>
                </div>
            </Modal>
        </Card>

        <Modal v-model="listModal.show"
            title="调拨单"
            :width="80"
            class-name="vertical-center-modal">
            <stand-pagination-table :columns="listModal.table.columns"
                :data="listModal.table.rows"
                :loading="listModal.table.loading"
                :table-search="listModal.table.tableSearch"
                :table-load-event="getTransformListRecord" />
            </Col>

        </Modal>

        <Modal v-model="importModel.show"
            title="请选择要导入的文件"
            :mask-closable="false"
            @on-ok="onImportEntry"
            :loading="true"
            width=300>
            <div style="display:flex;justify-content: space-between;">
                <Upload :show-upload-list="false"
                    :action="UPLOAD_FILE_API"
                    :format="['xlsx']"
                    :on-success="handleSuccess"
                    :on-format-error="handleFormatError">
                    <Button icon="ios-cloud-upload-outline">选择文件</Button>
                </Upload>

                <Button icon="ios-cloud-download-outline"
                    @click="downloadImportTemplate()">下载模板</Button>
            </div>
            <div>{{importModel.fileName}}</div>
        </Modal>

        <Modal v-model="transToPreformModal.show"
            :width="60"
            title="现售库调拨"
            class-name="vertical-center-modal">
            <Form label-position="top"
                class="small-form">
                <Row :gutter="16">
                    <Col span="6">
                    <FormItem label="仓库">
                        <Input :value="transToPreformModal.warehouseName"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="产品编号">
                        <Input :value="transToPreformModal.productCode"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="产品名称">
                        <Input :value="transToPreformModal.productName"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="批次号">
                        <Input :value="transToPreformModal.transformBatchCode"
                            readonly></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="6">
                    <FormItem label="仓存量">
                        <Input :value="transToPreformModal.Amount"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="销售期限">
                        <Input :value="transToPreformModal.transformSalePeriod"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="过鲜日期">
                        <Input :value="formatDateTimeString(transToPreformModal.expiredDate)"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="入库价">
                        <Input :value="transToPreformModal.transformPrice"
                            readonly></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="6">
                    <FormItem label="目标仓库">
                        <Input value="预售仓"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="调拨数量">
                        <InputNumber v-model="transToPreformModal.transformAmount"
                            :max="transToPreformModal.Amount"
                            :min="0"
                            style="width:100%;"></InputNumber>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="备注">
                        <Input v-model="transToPreformModal.transformRemark"></Input>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="primary"
                    :loading="btnLoading"
                    @click="onTransformToPre">确认</Button>
                <Button type="error"
                    @click="transToPreformModal.show=false">取消</Button>
            </div>
        </Modal>

        <CurWarehouseEntryList ref="curWarehouseEntryList" />
        <CurAgentWarehouseEntryList ref="curAgentWarehouseEntryList" />
        <CurSaleWarehouseDiscardList ref="curSaleWarehouseDiscardList" />

    </div>

</template>

<script>
import { currencyRender, dateRender } from '@/libs/tableRowTimeRender';
import SearchCard from '@/components/searchCard/searchCard.vue';
import CurrencyInput from '@/components/number-input/currency-input';
import IntegerInput from '@/components/number-input/integer-input';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import CurWarehouseEntryList from './../../curSale-management/curSale-warehouse-entry/curSale-warehouse-entry-list';
import CurSaleWarehouseDiscardList from './curSale-warehouse-discard-list';
import CurAgentWarehouseEntryList from './../../curSale-management/curSale-warehouse-entry/curSale-agent-warehouse-entry-list';
import { curSaleUpdateAdjustPrice, getCurSaleWarehouseProductStore, curSaleInnerOuterTransfer } from '@/api/modules/warehouse-management/warehouse';
import { importCurSaleWarehouseEntry } from '@/api/modules/warehouse-management/warehouseEntry';
import { DOWNLOAD_SERVER, UPLOAD_FILE_API } from '@/api/modules/files';
import { getWarehouseTransformList, transformWarehouseEntryToPre } from '@/api/modules/warehouse-management/warehouseEntry';
import { formatDateTimeString } from '@/libs/logic';

export default {
    name: 'CurSaleWarehouseStore',
    components: {
        CurrencyInput,
        IntegerInput,
        StandPaginationTable,
        SearchCard,
        CurWarehouseEntryList,
        CurSaleWarehouseDiscardList,
        CurAgentWarehouseEntryList
    },
    data() {
        return {
            UPLOAD_FILE_API,
            amountFilter: true,
            btnLoading: false,
            mainTable: {
                columns: [
                    { title: '仓库', key: 'warehouseName', width: 140, align: 'center', excel: true },
                    { title: '产品编号', key: 'productCode', width: 80, align: 'center', excel: true },
                    { title: '产品名称', key: 'productName', width: 80, align: 'center', excel: true },
                    { title: '小类', key: 'subCategoryName', width: 100, align: 'center', excel: true },
                    { title: '批次号', key: 'warehouseProductStoreBatchCode', width: 100, align: 'center', excel: true },
                    { title: '入库量', key: 'entryAmount', width: 80, align: 'center', excel: true },
                    { title: '发货量', key: 'deliveryAmount', width: 80, align: 'center', excel: true },
                    { title: '报损量', key: 'discardAmount', width: 80, align: 'center', excel: true },
                    { title: '调拨量', key: 'transferAmount2', width: 80, align: 'center', excel: true },
                    { title: '转换量', key: 'transferAmount', width: 80, align: 'center', excel: true },
                    { title: '可供销售量', key: 'warehouseProductStoreAmountFront', width: 80, align: 'center', excel: true },
                    { title: '仓存量', key: 'warehouseProductStoreAmount', width: 80, align: 'center', excel: true },
                    {
                        title: '公开', key: 'warehouseProductStoreIsPublic', width: 80, align: 'center', excel: true,
                        render: (h, params) => {
                            let text = '';
                            if (params.row.warehouseProductStoreIsPublic === 1) {
                                text = '是';
                            }
                            else if (params.row.warehouseProductStoreIsPublic === 0) {
                                text = '否';
                            }
                            let color = params.row.warehouseProductStoreIsPublic === 1 ? '' : 'red';
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: color
                                    }
                                }, text)
                            ]);
                        }
                    },
                    { title: '销售期限', key: 'warehouseProductStoreSalePeriod', width: 80, align: 'center', excel: true },
                    { title: '过鲜日期', key: 'warehouseProductStoreExpireDate', width: 80, align: 'center', excel: true, render: (h, params) => dateRender(h, params.row.warehouseProductStoreExpireDate) },
                    { title: '定价阶段', key: 'warehouseProductStoreStep', width: 80, align: 'center', excel: true },
                    {
                        title: '调价机制', key: 'productIsAutoAdjustPrice', width: 80, align: 'center',
                        render: (h, params) => {
                            let text = '';
                            if (params.row.productIsAutoAdjustPrice === 1) {
                                text = '自动调价';
                            }
                            else if (params.row.productIsAutoAdjustPrice === 0) {
                                text = '手工调价';
                            }
                            return h('div', [
                                h('span', {}, text)
                            ]);
                        }
                    },
                    { title: '最新价', key: 'warehouseProductStoreBatchPrice', width: 80, align: 'center', excel: true, render: (h, params) => currencyRender(h, params.row.warehouseProductStoreBatchPrice) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 140,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return '';
                            }
                            else {
                                let text = params.row.warehouseProductStoreIsPublic === 1 ? '转内部' : '转公开';
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                            visibility: this.$checkAccessArray(['B', 'C']) ? 'visible' : 'hidden'
                                        },
                                        on: {
                                            click: () => {
                                                this.transferModal.form.warehouseProductStoreUuid = params.row.warehouseProductStoreUuid;
                                                this.transferModal.form.transferCount = params.row.warehouseProductStoreAmount;
                                                this.transferModal.show = true;
                                            }
                                        }
                                    }, text),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle',
                                            disabled: params.row.warehouseProductStoreStep !== 'A' || params.row.warehouseProductStoreAmount === 0
                                        },
                                        style: {
                                            visibility: this.$checkAccessArray(['B', 'C']) ? 'visible' : 'hidden'
                                        },
                                        on: {
                                            click: () => {
                                                this.adjustModal.form.warehouseProductStoreUuid = params.row.warehouseProductStoreUuid;
                                                this.adjustModal.form.warehouseProductStoreLastAdjustPrice = params.row.warehouseProductStoreBatchPrice;
                                                this.adjustModal.show = true;
                                            }
                                        }
                                    }, '调价'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                        },
                                        on: {
                                            click: () => {
                                                this.onClickTransferToPre(params.row);
                                            }
                                        }
                                    }, '调拨')
                                ]);
                            }
                        }
                    }
                ],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '产品信息', type: 'Input', value: '', name: 'Concat(productCode, productName)', sql: 'like' },
                    { label: '批次号', type: 'Input', value: '', name: 'warehouseProductStoreBatchCode', sql: 'like' },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' }
                ]
            },
            storeList: [],
            transferModal: {
                show: false,
                loading: false,
                form: {
                    warehouseProductStoreUuid: '',
                    transferCount: 0
                }
            },
            adjustModal: {
                show: false,
                loading: false,
                form: {
                    warehouseProductStoreUuid: '',
                    warehouseProductStoreLastAdjustPrice: 0
                }
            },
            transToPreformModal: {
                show: false,
                warehouseProductStoreUuid: '',
                warehouseName: '',
                productCode: '',
                productName: '',
                transformBatchCode: '',
                Amount: 0,
                transformSalePeriod: 0,
                expiredDate: '',
                transformAmount: 0,
                transformPrice: 0,
                transformRemark: '商品调拨'
            },
            listModal: {
                show: false,
                table: {
                    rows: [],
                    columns: [
                        { title: '单号', key: 'warehouseEntryTransformRecordBillCode', width: 150, align: 'center' },
                        { title: '目标仓', key: 'warehouseEntryTransformRecordTarget', align: 'center' },
                        { title: '产品编号', key: 'warehouseEntryTransformRecordProductCode', align: 'center' },
                        { title: '产品名称', key: 'warehouseEntryTransformRecordProductName', align: 'center' },
                        { title: '批次号', key: 'warehouseEntryTransformRecordBatchCode', align: 'center' },
                        { title: '调拨量', key: 'warehouseEntryTransformRecordAmount', align: 'center' },
                        { title: '经办', key: 'warehouseEntryTransformRecordOperator', align: 'center' },
                        { title: '调拨时间', key: 'warehouseEntryTransformRecordCreatedAt', align: 'center', render: (h, params) => dateRender(h, params.row.warehouseEntryTransformRecordCreatedAt) },
                        { title: '备注', key: 'warehouseEntryTransformRecordRemark', align: 'center' }
                    ],
                    loading: false,
                    tableSearch: search.getSearchParams()
                }
            },
            importModel: {
                show: false,
                loading: false,
                fileWebName: '',
                fileName: ''
            }
        };
    },
    created() {
        if (this.$checkAccessArray(["B", "C"]) === false) {
            const findIndex = this.mainTable.columns.findIndex(c => c.title === "操作");
            if (findIndex >= 0) {
                this.mainTable.columns.splice(findIndex, 1);
            }
        }
    },
    mounted() {
        this.getMainTableRecords();
    },
    methods: {
        formatDateTimeString,
        handleSuccess(res, file) {
            this.importModel.fileWebName = res.data.fileList[0].fileUuid;
            this.importModel.fileName = res.data.fileList[0].fileName;
        },
        handleFormatError(file) {
            const str = this.format.join(', ');
            this.$Notice.warning({
                title: '文件格式错误',
                desc: '请选择 ' + str + ' 后缀的文件.'
            });
        },
        onClickTransferToPre(row) {
            // console.log(row);
            this.transToPreformModal.warehouseProductStoreUuid = row.warehouseProductStoreUuid;
            this.transToPreformModal.productCode = row.productCode;
            this.transToPreformModal.productName = row.productName;
            this.transToPreformModal.warehouseName = row.warehouseName;
            this.transToPreformModal.transformBatchCode = row.warehouseProductStoreBatchCode;
            this.transToPreformModal.Amount = row.warehouseProductStoreAmount;
            this.transToPreformModal.transformSalePeriod = row.warehouseProductStoreSalePeriod;
            this.transToPreformModal.expiredDate = row.warehouseProductStoreExpireDate;
            this.transToPreformModal.transformPrice = row.warehouseProductStoreBatchPrice;
            this.transToPreformModal.transformAmount = 0;
            this.transToPreformModal.tranformRemark = '';
            this.transToPreformModal.show = true;

        },
        onTransformToPre() {
            if (this.transToPreformModal.transformAmount > this.transToPreformModal.Amount) {
                this.$Modal.error({ title: '出错啦', content: '调拨数量不能大于仓存量' });
                return;
            }
            this.btnLoading = true;
            transformWarehouseEntryToPre(this.transToPreformModal).then(res => {
                this.btnLoading = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '调拨成功',
                        onOk: () => {
                            this.transToPreformModal.show = false;
                            this.getMainTableRecords();
                        }
                    });
                }
            });
        },
        onClickImport() {
            this.importModel.fileName = '';
            this.importModel.fileWebName = '';
            this.importModel.show = true;
        },
        onImportEntry() {
            importCurSaleWarehouseEntry({ importFileName: this.importModel.fileWebName }).then(res => {
                this.importModel.show = false;
                if (res.code === 0) {
                    this.getMainTableRecords();
                    this.$Modal.success({
                        title: '导入成功',
                        content: ''
                    });
                }
            });
        },
        downloadImportTemplate() {
            let url = DOWNLOAD_SERVER + 'Import/template/cursale_entry_import_template.xlsx';
            this.$downLoadFile(url);
            // window.open(FILE_SERVER + "Import/template/cursale_entry_import_template.xlsx", "_blank");
        },

        onExport() {
            const searchCondition = search.deepClone(this.mainTable.tableSearch);
            searchCondition.limit.enable = false;
            searchCondition.excelExport.enable = true;
            searchCondition.excelExport.columns = this.mainTable.columns
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });

            this.mainTable.tableLoading = true;
            getCurSaleWarehouseProductStore(searchCondition).then(res => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.exportFileName;
                    this.$downLoadFile(url);
                    // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                }
            });
        },
        onDiscard() {
            this.$refs.curSaleWarehouseDiscardList.showModal();
        },
        onEntry() {
            this.$refs.curWarehouseEntryList.showModal();
        },
        onAgentEntry() {
            this.$refs.curAgentWarehouseEntryList.showModal();
        },
        onTransformList() {
            this.listModal.show = true;
            this.getTransformListRecord();
        },
        getTransformListRecord() {
            this.listModal.table.loading = true;
            this.listModal.table.tableSearch.source = "现售仓";
            getWarehouseTransformList(this.listModal.table.tableSearch).then(res => {
                this.listModal.table.loading = false;
                this.listModal.table.rows = res.data.records;
                search.globalSetFilterRecordCount(this.listModal.table.tableSearch, res.data.filterRecordCount);
            });
        },
        onShowHasStockOnly() {
            this.getMainTableRecords(true);
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            this.mainTable.tableSearch.amountFilter = this.amountFilter ? 1 : 0;
            this.mainTable.tableLoading = true;
            getCurSaleWarehouseProductStore(this.mainTable.tableSearch).then(res => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    this.storeList = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);

                    let totalAmount = 0;
                    let totalAmountFront = 0;
                    this.storeList.forEach(e => {
                        totalAmountFront += e.warehouseProductStoreAmountFront;
                        totalAmount += e.warehouseProductStoreAmount;
                    });
                    this.storeList.push({
                        warehouseProductStoreAmountFront: totalAmountFront,
                        warehouseProductStoreAmount: totalAmount,
                        transferAmount: '合计',
                        warehouseProductStoreBatchPrice: null,
                        action: -1
                    });
                }
            }).catch(() => {
                this.mainTable.tableLoading = false;
            });
        },
        onTransfer() {
            this.transferModal.loading = true;
            curSaleInnerOuterTransfer(this.transferModal.form).then(res => {
                this.transferModal.show = false;
                this.transferModal.loading = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '转换成功',
                        onOk: () => {
                            this.getMainTableRecords();
                        }
                    });
                }
            });
        },
        onAdjustPrice() {
            this.mainTable.tableLoading = true;
            curSaleUpdateAdjustPrice(this.adjustModal.form).then(res => {
                this.adjustModal.show = false;
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '调价成功',
                        onOk: () => {
                            this.getMainTableRecords();
                        }
                    });
                }
            }).catch(() => {
                this.adjustModal.show = false;
                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
